const o = "styles-module__container___52dYg", e = "styles-module__loader___MwFYk", _ = "styles-module__body___gsAjP", s = {
  container: o,
  loader: e,
  body: _
};
export {
  _ as body,
  o as container,
  s as default,
  e as loader
};
